/* ==========================================================================
   LF Outlet, Arma tu pack
   El cliente suma y resta perfumes hasta completar las unidades del pack.
   Recién ahí se activa el botón. El pack entra al carrito como un solo
   producto, con su precio, y una propiedad "Selección" con el detalle:
   "Lattafa Khamrah 200ml ×5, Lattafa Asad 200ml ×3, ..." — que se ve en el
   carrito, en el checkout y en el pedido del admin.

   Muestras de 5 ml (si el bloque las trae): el cliente elige aromas en una
   fila aparte. Las primeras N son de regalo y se anotan en el pack
   ("Muestras 5 ml"); las que pasan de N entran como el producto "Muestra
   extra 5 ml", una unidad por muestra, en el mismo envío al carrito.
   ========================================================================== */
(function () {
  'use strict';

  if (customElements.get('lf-pack')) return;

  class LfPack extends HTMLElement {
    connectedCallback() {
      if (this.dataset.listo === 'si') return;
      this.dataset.listo = 'si';

      this.total = parseInt(this.dataset.unidades, 10) || 0;
      this.disponible = this.dataset.disponible === 'true';
      this.opciones = Array.from(this.querySelectorAll('[data-lf-opcion]'));
      this.cantidades = new Map(this.opciones.map((o) => [o, 0]));

      this.llevas = this.querySelector('[data-lf-llevas]');
      this.estado = this.querySelector('[data-lf-estado]');
      this.barra = this.querySelector('[data-lf-barra]');
      this.boton = this.querySelector('[data-lf-boton]');
      this.seleccion = this.querySelector('[data-lf-seleccion]');
      this.error = this.querySelector('[data-lf-error]');
      this.vaciar = this.querySelector('[data-lf-vaciar]');
      this.buscar = this.querySelector('[data-lf-buscar]');
      this.sinResultados = this.querySelector('[data-lf-sin-resultados]');
      this.form = this.querySelector('[data-lf-form]');

      this.precioPack = parseInt(this.dataset.precioPack, 10) || 0;
      this.muestras = Array.from(this.querySelectorAll('[data-lf-muestra]'));
      this.cantMuestras = new Map(this.muestras.map((o) => [o, 0]));
      this.gratis = parseInt(this.dataset.muestrasGratis, 10) || 0;
      this.topeExtra = parseInt(this.dataset.muestrasTope, 10) || 0;
      this.precioMuestra = parseInt(this.dataset.muestraPrecio, 10) || 0;
      this.extra = this.querySelector('[data-lf-extra]');
      this.muestrasValor = this.querySelector('[data-lf-muestras-valor]');

      this.addEventListener('click', (e) => {
        const mas = e.target.closest('[data-lf-mas]');
        const menos = e.target.closest('[data-lf-menos]');
        if (mas) this.cambiar(mas.closest('[data-lf-opcion]'), 1);
        if (menos) this.cambiar(menos.closest('[data-lf-opcion]'), -1);
        const masM = e.target.closest('[data-lf-muestra-mas]');
        const menosM = e.target.closest('[data-lf-muestra-menos]');
        if (masM) this.cambiarMuestra(masM.closest('[data-lf-muestra]'), 1);
        if (menosM) this.cambiarMuestra(menosM.closest('[data-lf-muestra]'), -1);
      });

      if (this.vaciar) {
        this.vaciar.addEventListener('click', () => {
          this.opciones.forEach((o) => this.cantidades.set(o, 0));
          this.pintar();
        });
      }

      if (this.buscar) {
        this.buscar.addEventListener('input', () => this.filtrar(this.buscar.value));
      }

      if (this.form) {
        this.form.addEventListener('submit', (e) => {
          e.preventDefault();
          this.agregar();
        });
      }

      this.pintar();
    }

    suma() {
      let s = 0;
      this.cantidades.forEach((c) => { s += c; });
      return s;
    }

    // -1 = sin tope; si no, es el stock real de ese aroma
    tope(opcion) {
      const s = parseInt(opcion.dataset.stock, 10);
      return Number.isNaN(s) ? -1 : s;
    }

    cambiar(opcion, delta) {
      if (!opcion) return;
      const actual = this.cantidades.get(opcion) || 0;
      const siguiente = actual + delta;
      if (siguiente < 0) return;
      if (delta > 0 && this.suma() >= this.total) return;
      const tope = this.tope(opcion);
      if (delta > 0 && tope >= 0 && siguiente > tope) return;
      this.cantidades.set(opcion, siguiente);
      this.ocultarError();
      this.pintar();
    }

    sumaMuestras() {
      let s = 0;
      this.cantMuestras.forEach((c) => { s += c; });
      return s;
    }

    extras() {
      return Math.max(0, this.sumaMuestras() - this.gratis);
    }

    cambiarMuestra(opcion, delta) {
      if (!opcion) return;
      const siguiente = (this.cantMuestras.get(opcion) || 0) + delta;
      if (siguiente < 0) return;
      if (delta > 0 && this.sumaMuestras() >= this.gratis + this.topeExtra) return;
      this.cantMuestras.set(opcion, siguiente);
      this.ocultarError();
      this.pintar();
    }

    pesos(n) {
      return n.toLocaleString('es-CL');
    }

    lista(opciones, cantidades) {
      const partes = [];
      opciones.forEach((o) => {
        const c = cantidades.get(o);
        if (c > 0) partes.push(`${o.dataset.nombre} ×${c}`);
      });
      return partes.join(', ');
    }

    pintarMuestras() {
      if (!this.muestras.length) return;
      const suma = this.sumaMuestras();
      const extras = this.extras();
      const lleno = suma >= this.gratis + this.topeExtra;

      this.muestras.forEach((o) => {
        const c = this.cantMuestras.get(o);
        o.querySelector('[data-lf-muestra-cantidad]').textContent = c;
        o.querySelector('[data-lf-muestra-menos]').disabled = c === 0;
        o.querySelector('[data-lf-muestra-mas]').disabled = lleno;
        o.classList.toggle('esta-elegida', c > 0);
      });

      if (this.extra) {
        this.extra.hidden = extras === 0;
        this.extra.textContent = `${extras} ${extras === 1 ? 'muestra extra' : 'muestras extra'}: +$${this.pesos(extras * this.precioMuestra)}`;
      }

      if (this.muestrasValor) {
        this.muestrasValor.value = suma > 0 ? this.lista(this.muestras, this.cantMuestras) : 'Surtidas';
      }
    }

    texto(plantilla, n) {
      return (plantilla || '').replace('[n]', n);
    }

    pintar() {
      const suma = this.suma();
      const falta = this.total - suma;
      const lleno = falta === 0;

      this.opciones.forEach((o) => {
        const c = this.cantidades.get(o);
        const tope = this.tope(o);
        o.querySelector('[data-lf-cantidad]').textContent = c;
        o.querySelector('[data-lf-menos]').disabled = c === 0;
        o.querySelector('[data-lf-mas]').disabled = lleno || tope === 0 || (tope > 0 && c >= tope);
        o.classList.toggle('esta-elegida', c > 0);
      });

      this.llevas.textContent = suma;
      this.barra.style.width = `${Math.round((suma / this.total) * 100)}%`;
      this.barra.parentElement.classList.toggle('esta-lista', lleno);
      this.estado.textContent = lleno ? '¡Pack completo!' : `Te faltan ${falta}`;
      this.estado.classList.toggle('esta-listo', lleno);
      if (this.vaciar) this.vaciar.hidden = suma === 0;

      if (!this.disponible) {
        this.boton.disabled = true;
        this.boton.textContent = this.dataset.textoAgotado;
      } else {
        this.boton.disabled = !lleno;
        if (lleno) {
          const extras = this.extras();
          this.boton.textContent = extras > 0 && this.dataset.textoListoPlantilla
            ? this.dataset.textoListoPlantilla.replace('[total]', this.pesos(this.precioPack + extras * this.precioMuestra))
            : this.dataset.textoListo;
        } else if (suma === 0) {
          this.boton.textContent = `Elige tus ${this.total}`;
        } else {
          this.boton.textContent = this.texto(this.dataset.textoFaltan, falta);
        }
      }

      // la línea que va al carrito y al pedido
      this.seleccion.value = this.lista(this.opciones, this.cantidades);
      this.pintarMuestras();
    }

    filtrar(consulta) {
      const q = consulta.trim().toLowerCase();
      let visibles = 0;
      this.opciones.forEach((o) => {
        const coincide = !q || o.dataset.busqueda.includes(q);
        // lo que ya está elegido nunca se esconde
        o.hidden = !coincide && this.cantidades.get(o) === 0;
        if (!o.hidden) visibles += 1;
      });
      if (this.sinResultados) this.sinResultados.hidden = visibles > 0;
    }

    mostrarError(texto) {
      this.error.textContent = texto;
      this.error.hidden = false;
    }

    ocultarError() {
      this.error.hidden = true;
    }

    async agregar() {
      if (this.suma() !== this.total || !this.disponible) return;

      const textoPrevio = this.boton.textContent;
      this.boton.disabled = true;
      this.boton.textContent = 'Agregando…';

      const ruta = `${this.form.getAttribute('action')}.js`;
      let peticion;
      if (this.muestras.length) {
        // pack y muestras extra en un solo envío: entran juntos o no entra nada
        const datos = new FormData(this.form);
        const propiedades = { 'Selección': this.seleccion.value, 'Muestras 5 ml': this.muestrasValor.value };
        const items = [{ id: Number(datos.get('id')), quantity: 1, properties: propiedades }];
        const extras = this.extras();
        if (extras > 0) {
          items.push({ id: Number(this.dataset.muestraVariante), quantity: extras, properties: { Pack: this.dataset.packNombre } });
        }
        peticion = {
          method: 'POST',
          headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
          body: JSON.stringify({ items }),
        };
      } else {
        peticion = { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(this.form) };
      }

      try {
        const r = await fetch(ruta, peticion);
        const cuerpo = await r.json().catch(() => ({}));
        if (!r.ok) {
          this.mostrarError(cuerpo.description || cuerpo.message || 'No se pudo agregar el pack. Intenta de nuevo.');
          this.boton.textContent = textoPrevio;
          this.boton.disabled = false;
          return;
        }
        // el carrito lateral se abre con lo agregado; sin carrito lateral
        // (la página /cart o el ajuste "página"), se va al carrito
        this.boton.textContent = textoPrevio;
        this.boton.disabled = false;
        const abierto = window.lfAvisarCarrito ? await window.lfAvisarCarrito('lf-pack') : false;
        if (!abierto) window.location.href = this.dataset.carrito || '/cart';
      } catch (e) {
        this.mostrarError('No se pudo agregar el pack. Revisa tu conexión e intenta de nuevo.');
        this.boton.textContent = textoPrevio;
        this.boton.disabled = false;
      }
    }
  }

  customElements.define('lf-pack', LfPack);
})();
